'use client'

import { useRouter } from 'next/navigation'
import { useActionState } from 'react'
import { notification } from './notification'
import type { ServerActionResponse } from './serverActionsResponse'

const initialState = {
  message: 'Pending',
  status: 'pending',
} satisfies ServerActionResponse

export function useAction<
  Action extends (...args: any[]) => Promise<ServerActionResponse>,
>(
  action: Action,
  callback?: (
    data?: Extract<Awaited<ReturnType<Action>>, { status: 'success' }>['body'],
  ) => void,
) {
  const router = useRouter()
  const [, formAction] = useActionState(
    async (state: ServerActionResponse, formData: FormData) => {
      const response = await action(state, formData)
      notifyUser(response)
      if (response.status === 'success') {
        if (response.redirect) {
          router.push(response.redirect)
        }
        callback?.(response.body)
      }
      return response
    },
    initialState,
  )

  return formAction
}

export function notifyUser(props: ServerActionResponse) {
  if (props.status === 'error') {
    notification.error({
      title: props.title || 'Fehler',
      body: props.message || 'Ein Fehler ist aufgetreten',
      note: props.eventId && `Event ID: ${props.eventId}`,
    })
  } else if (props.status === 'success') {
    if ('message' in props) {
      notification.success({
        title: props.title || 'Erfolgreich',
        body: props.message,
        id: 'success',
      })
    }
  } else if (props.status === 'invalid') {
    notification.info({
      title: 'Validierung fehlgeschlagen',
      body: props.message,
    })
  } else if (props.status === 'info') {
    notification.info({
      title: 'Hinweis',
      body: props.message,
    })
  }
}
